import React from 'react';
import { Icon } from '@chakra-ui/icons';

export const ActionCopyReflink = ({ color = 'white' }: { color?: string }) => {
	return (
		<Icon
			width="15px"
			height="15px"
			viewBox="0 0 15 15"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12.5 5.48096H6.875C6.18464 5.48096 5.625 6.0406 5.625 6.73096V12.356C5.625 13.0463 6.18464 13.606 6.875 13.606H12.5C13.1904 13.606 13.75 13.0463 13.75 12.356V6.73096C13.75 6.0406 13.1904 5.48096 12.5 5.48096Z"
				stroke={color}
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M3.125 9.23096H2.5C2.16848 9.23096 1.85054 9.09926 1.61612 8.86484C1.3817 8.63042 1.25 8.31248 1.25 7.98096V2.35596C1.25 2.02444 1.3817 1.70649 1.61612 1.47207C1.85054 1.23765 2.16848 1.10596 2.5 1.10596H8.125C8.45652 1.10596 8.77446 1.23765 9.00888 1.47207C9.2433 1.70649 9.375 2.02444 9.375 2.35596V2.98096"
				stroke={color}
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Icon>
	);
};
